import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createObjectCollectionReduceObject } from '../../../../../common/reducers/objectCollection/reducer';

import userBlackListCollectionSaga from './sagas/userBlackListCollectionSaga';

export default [
  // Lists
  ...createCombineMapItem(
    'userBlackListCollection',
    createObjectCollectionReduceObject,
    [userBlackListCollectionSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userBlackList/reducers/static/collections/reducersMap.js